import React, { useState, useEffect } from 'react'
import { useDispatch , useSelector } from 'react-redux'
// import { Link } from 'react-router-dom';
import {CardMedia,Avatar,CssBaseline,TextField,FormControlLabel,Checkbox,Link,
    Button,Typography ,
    Paper,
    Grid,
    Box,
    FormControl } from '@mui/material'
    import { createTheme, ThemeProvider } from '@mui/material/styles';
    import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import FormContainer from '../components/FormContainer'
import { register } from '../actions/userActions'
import Message from '../components/Message'
import Loader from '../components/Loader'
import Alert from '@mui/material/Alert';
import QrReader from 'react-qr-reader'

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="#">
        Afzal Warehouse
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();

const RegisterScreen = ({ location, history }) => {
    
  const [nickname, setnickname] = useState('')
  const [first_name, setfirst_name] = useState('')
  const [last_name, setlast_name] = useState('')
  const [phone, setphone] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState(null)

  const dispatch = useDispatch()

  const userRegister = useSelector((state) => state.userRegister)
  const { loading, error, userInfo } = userRegister

  const redirect = location.search ? location.search.split('=')[1] : '/'

  useEffect(() => {
    if (userInfo) {
      history.push(redirect)
    }
  }, [history, userInfo, redirect])

  const submitHandler = (e) => {
    e.preventDefault()
    if (password !== confirmPassword) {
      setMessage('Passwords do not match')
    } else {
      dispatch(register(nickname,first_name,last_name,phone, email, password))
    }
  }

    return (

      <ThemeProvider theme={theme}>

      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: 'url(https://source.unsplash.com/random)',
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>

          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
                      {message && <Alert severity="error" variant="filled">{message}</Alert>}
        {error && <Alert severity="error" variant="filled">{error}</Alert>}
        {loading && <Loader />}
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign Up
            </Typography>
            <div>
        <QrReader
          delay={300}
          // onError={this.handleError}
          // onScan={this.handleScan}
          style={{ width: '100%' }}
        />
        <p></p>
      </div>
            <Box component="form" noValidate onSubmit={submitHandler} sx={{ mt: 1 }}>
            <TextField
                margin="normal"
                required
                fullWidth
                id="nickname"
                label="Nick name"
                name="nickname"
                autoComplete="nickname"
                autoFocus
                value={nickname}
                onChange={(e) => setnickname(e.target.value)} 
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="first_name"
                label="First Name"
                name="first_name"
                autoComplete="first_name"
                autoFocus
                value={first_name}
                onChange={(e) => setfirst_name(e.target.value)} 
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="last_name"
                label="Last Name"
                name="last_name"
                autoComplete="last_name"
                autoFocus
                value={last_name}
                onChange={(e) => setlast_name(e.target.value)} 
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="phone"
                label="Phone"
                name="phone"
                autoComplete="phone"
                autoFocus
                value={phone}
                onChange={(e) => setphone(e.target.value)} 
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)} 
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)} 
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                id="confirmPassword"
                autoComplete="current-password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)} 
              />
              {/* <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              /> */}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Sign Up
              </Button>
              {/* <Grid container>
                <Grid item xs>
                  <Link href="#" variant="body2">
                    Forgot password?
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="#" variant="body2">
                    {"Don't have an account? Sign Up"}
                  </Link>
                </Grid>
              </Grid> */}
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
    )
}

export default RegisterScreen
